module.exports = {
  loading: 'loading',
  logout: 'Log Out',
  logoutDesc: 'Are you sure you want to logout?',
  check: 'Check',
  asntitle: 'QUizZZ Time',
  asntitle2: 'Quizzes Reamaining',
  Correct: 'Correct',
  wrong: 'WRONG',
  ansTitle1: 'Awesome!',
  ansTitle2: 'You still got ',
  ansTitle22: 'card for this wrong answer!',
  ansTitle3: 'That was close!',
  congratulations: 'Congratulations!',
  otp: 'otp',
  ladingpageTips: '(Free of charge from 9th Jan - 7th Feb)',
  ladingpageTips2: 'For New Users only!',
  Daily: 'Daily',
  dailyM: '179 Ks',
  Weekly: 'Weekly',
  weeklyM: '799 Ks',
  Monthly: 'Monthly',
  monthlyM: '3999 Ks',
  subscribeNow: 'Subscribe',
  Copyright: 'Copyright © Grab&Get 2026',
  CopySucceeded: 'Copy succeeded',
  play: 'choose me',
  myAccount: 'Personal info',
  profile: 'Profile',
  FAQs: 'FAQs',
  TC: 'T&C',
  language: 'Language',
  PickLanguage: 'Pick a Language',
  Submit: 'Submit',
  change: 'change',
  English: 'English',
  showMore: 'See More',
  Login: 'Login',
  Logout: 'Log out',
  getCode: 'Send',
  sendCode: 'Send',
  phoneNumber: 'PHONE NUMBER',
  enderNumber: 'Enter phone number',
  Name: 'username',
  address: 'Address',
  phone: 'Phone',
  Prize: 'Prize',
  referral: 'Referral',
  winnerList: 'Winner List',
  Date: 'Date',
  Save: 'Save',
  cancel: 'cancel',
  Confirm: 'Confirm',
  goBack: 'go back',
  No: 'No',
  OK: 'OK',
  Yes: 'Yes',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  noMore: 'No more',
  more: 'More',
  ohNo: 'Oh No',
  subDes2: 'We’re sad to see you go!',
  des2: 'Are you sure you want to unsubscribe?',
  boxes: 'TOTAL Score',
  box: 'Total Card',
  referralTips1: "Invite a new user to get the rewards.1000 Scores  will be reward to both invitee and inviter.",
  memberGetMember: 'member-get-member',
  referralTips2: 'This is your referral ID',
  referralTips3: 'This is your friends referral ID',
  Status: 'Status',
  noFound: 'Ooops! <br />Found no results!',
  cgtips1: 'WIN GRAND PRIZE !!!',
  cgtips2: 'Only 149ks/daily,<br />please click OK to subscribe.',
  cgtips2W: 'Only 599ks/weekly,<br />please click OK to subscribe.',
  cgtips2M: 'Only 1999ks/monthly,<br />please click OK to subscribe.',
  indexbutton1: 'Game Choose',
  getMorecards: 'to get more score',
  indexbutton2: 'choose 9x times',
  landFont1: 'Enter a phone number',
  landFont2: 'Choose package',
  landingFont: 'Charging of subscription fee will happen from main balance.',
  optTips: 'You have already subscribed, please click OK to get the login code',
  landingContent: '<div class="ac">Mytel generic Terms & Conditions</div><br />1.The service will be eligible to use for 365 days with daily/ weekly/ monthly installment fees based on the service typed you choose.<br /><br />2.The Mytel collected fees for the use of service usage frequency for a time (for example, non renewal or daily, and there is no charge) or installment billing method ( eg weekly /monthly charge based on 365 days of the service may be).<br /><br />3.If the Mytel’s partner (third party) would provide/ serve the trial period for their service, customer can enjoy the trial period till the expiry date. Then, we may charge based on your chosen service even after the trial period is expired. And you will get charged from your mobile balance for the daily/ weekly/ monthly service fees after the trial period is end.Confirm that access the service due to these Terms of Service fees apply for recognition and acceptance confirmation.<br /><br />4.By clicking subscription you are accepting the Terms and Condition of the Service used.',
  Invitation_Link: 'This is your invitation link',
  Copy: 'Copy',
  Invitation_Count: 'Invitation Count',
  homeTotal1: 'Your Game Chances',
  homefont2: 'Flip a card for your lucky shot to win BIG PRIZES.',
  buyPack: 'Buy Pack',
  buyNow: 'Buy Now',
  buyContent: 'Buy a package of 1 game chance, To get more score',
  luckyTips1: 'Each cards have a chance to win the followng prizes.',
  alertTips: 'You have successfully invited the following users:',
  personalInfo: 'Personal Info',
  invitation_log: 'Invitation History',
  ruleTask: 'Task Rule',
  DailyLogin: 'Daily Login',
  DailyLoginT1: 'Log in every day to unlock exciting rewards! The more you log in, the better the prizes!',
  Claim: 'Claim',
  Missed: 'Missed',
  ReClaim: 'ReClaim',
  DailyLoginT2: 'Reclaim Missed Reward!',
  DailyLoginT3: 'For just $0.06, you can claim your missed reward.',
  yesClaim: 'Yes, Claim',
  indexbutton12: 'Unlimited Available!',
  game_list: 'Choose Mini Games',
  Play: 'Play',
  Easy: 'Easy',
  Medium: 'Medium',
  Hard: 'Hard',
  Level: 'Level',
  ChooseTips1: 'Choose a Level 1, 2, or 3. <br />The higher the level, the better chances to win!',
  total_starts: "TOTAL Score",

  'Stars': 'Score',
  'Ranking': 'Ranking',
  'Packs': 'Packs',
  pkfont1: 'One Time Packs',
  pkfont2: 'One Time Purchase',
  pkfont3: '1 More Game chances',
  pkfont4: '129 Ks',
  pkfont21: 'VIP Royal Kit',
  pkfont22: 'For 30 Days',
  pkfont23: '5 Game chances / day, 200 Stars / day, VIP Logo & Frame',
  pkfont24: '3999 Ks',
  pkfont31: 'Weekly Packs',
  pkfont32: 'For 1 Week',
  pkfont33: '10 Game chances',
  pkfont34: '799 Ks',
  pkfont41: 'Daily Packs',
  pkfont42: 'Daily Subscription',
  pkfont43: '1 Game chances / day',
  pkfont44: '199 Ks',
  Yearly: 'Yearly',
  'Invitation successful!': 'Invitation successful!',
  invitTips1: 'You’ve earned \'1000 Score\' for inviting a new user!',
  'Card Name': 'Card Name',
  'Thank You': 'Thank You',
  'no prize found': 'no prize found',
  "Better luck next time!": 'Better luck next time!',
  LvL_1: 'LvL 1',
  LvL_2: 'LvL 2',
  LvL_3: 'LvL 3',
  level_tip1: "Flip a 'LvL 1' card with '100 Score'to win BIG PRIZES.",
  level_tip2: "Flip a 'LvL 2' card with '200 Score'to win BIG PRIZES.",
  level_tip3: "Flip a 'LvL 3' card with '300 Score'to win BIG PRIZES.",
  indexbutton3: 'Buy More Chances',
  loginTips: "Enter a phone number",
  upload_fail: "Upload failed",
  home_prize_tip: "Play Game and try your luck to win big prize!",
  buy_popup_tip1: "Buy More Chance",
  buy_popup_tip2: "Tap 'Buy Now' to buy more game chance with $0.06",
  Guidance: 'Guidance',
  Subscribe: 'Subscribe',
  DailyKyats: '149 Kyats',
  WeeklyKyats: '599 Kyats',
  OneTime: 'One Time',
  Purchase: 'Purchase',
  OneTimeChance: '129 Ks',
  lucky_draw: 'Lucky Draw',
  yearly_list: 'Yearly List',
  month_list: 'Monthly List',
  week_list: 'Weekly List',
  daily_tip: "Benefits: 2 Game chance ",
  weekly_tip: 'Benefits: <br /> Receive 4 Game chances on the first <br />day. <br /> Get 1 Game chance for each of the <br /> next six days.<br />Total: 10 Game Chance ',
  monthly_tip: 'Benefits: <br />5 Game chances per day<br />200 points<br />VIP Royal logo<br />VIP special profile frame (valid for <br />30 days)',
  buy_tip:"Benefits: 1 Change",
  daily_pack:"Daily Package",
  weekly_pack:"Weekly Package",
  monthly_pack:"Monthly Package",
  one_time_package:"One-Time Package",
  sub_tip:'To register easily<br />Dial *615# or send SMS HELP to *<br />To cancel the program, send OFF to 615.<br />',
  GrabGet:'Grab & Get',
  'Free Time':'Free Time',
  'chance':'chances',
  'goGet':'Go Get',
  'join_us':'You can join us by "615" also',
  'avatar':'Avatar',
  select_package:'Please select package',
  all_package:'All Package',
  daily_package:'Daily Package',
  weekly_package:'Weekly Package',
  monthly_package:'Monthly Package',
  best_choice:'BEST CHOICE',
  chances_2_day:'1 chances for using MetfoneGrabget / day',
  chances_14_day:'10 chances for using MetfoneGrabget / 7days',
  chances_60_day:'90 chances for using MetfoneGrabget / 30days',
  free_first_sub:'Free for first registration',
  register:'Register',

}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js